module.exports = __webpack_public_path__ + "img/oficina2.e33f9250.svg";